import { render, staticRenderFns } from "./ProductsConfiguration.vue?vue&type=template&id=79bcb85a"
import script from "./ProductsConfiguration.vue?vue&type=script&lang=js"
export * from "./ProductsConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports